var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.opened
    ? _c("div", { staticClass: "modal-mask" }, [
        _c("div", { staticClass: "modal-wrapper" }, [
          _c(
            "div",
            { staticClass: "modal-dialog modal-xl modal-dialog-scrollable" },
            [
              _c(
                "div",
                {
                  staticClass: "modal-content",
                  staticStyle: { height: "calc(100vh - 50px)" },
                },
                [
                  _c("div", { staticClass: "modal-header" }, [
                    _c("h5", { staticClass: "modal-title" }, [
                      _vm._v("Manage "),
                      _c("span", { staticClass: "text-lowercase" }, [
                        _vm._v(_vm._s(_vm.alternativesLabel)),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "close",
                        attrs: { type: "button" },
                        on: { click: _vm.close },
                      },
                      [_vm._v("×")]
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "modal-body" }, [
                    _c("div", { staticClass: "form-group" }, [
                      _c("label", [_vm._v("List:")]),
                      _vm._v(" "),
                      _c(
                        "select",
                        {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.viewDefId,
                              expression: "viewDefId",
                            },
                          ],
                          staticClass: "form-control",
                          on: {
                            change: function ($event) {
                              var $$selectedVal = Array.prototype.filter
                                .call($event.target.options, function (o) {
                                  return o.selected
                                })
                                .map(function (o) {
                                  var val = "_value" in o ? o._value : o.value
                                  return val
                                })
                              _vm.viewDefId = $event.target.multiple
                                ? $$selectedVal
                                : $$selectedVal[0]
                            },
                          },
                        },
                        [
                          _c("option", { domProps: { value: null } }, [
                            _vm._v("All"),
                          ]),
                          _vm._v(" "),
                          _vm._l(_vm.views, function (v) {
                            return _c("option", { domProps: { value: v.Id } }, [
                              _vm._v(_vm._s(v.Name)),
                            ])
                          }),
                        ],
                        2
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-group" }, [
                      _c("label", [_vm._v("Filter by attribute:")]),
                      _vm._v(" "),
                      _c(
                        "select",
                        {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.attributeId,
                              expression: "attributeId",
                            },
                          ],
                          staticClass: "form-control",
                          on: {
                            change: function ($event) {
                              var $$selectedVal = Array.prototype.filter
                                .call($event.target.options, function (o) {
                                  return o.selected
                                })
                                .map(function (o) {
                                  var val = "_value" in o ? o._value : o.value
                                  return val
                                })
                              _vm.attributeId = $event.target.multiple
                                ? $$selectedVal
                                : $$selectedVal[0]
                            },
                          },
                        },
                        [
                          _c("option", { domProps: { value: null } }, [
                            _vm._v("No selection"),
                          ]),
                          _vm._v(" "),
                          _vm._l(_vm.emailAttributes, function (attr) {
                            return _c(
                              "option",
                              { domProps: { value: attr.AttributeId } },
                              [_vm._v(_vm._s(attr.Name))]
                            )
                          }),
                        ],
                        2
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", [
                      _c("div", { staticClass: "d-flex justify-content-end" }, [
                        _c("div", { staticClass: "dropdown" }, [
                          _c(
                            "button",
                            {
                              staticClass:
                                "btn btn-sm btn-secondary dropdown-toggle",
                              attrs: { "data-toggle": "dropdown" },
                            },
                            [_vm._v("Insert")]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "dropdown-menu dropdown-menu-right",
                              staticStyle: {
                                "overflow-y": "auto",
                                "max-height": "400px",
                              },
                            },
                            [
                              _c(
                                "a",
                                {
                                  staticClass: "dropdown-item",
                                  on: {
                                    click: function ($event) {
                                      return _vm.insert("{Description}")
                                    },
                                  },
                                },
                                [_vm._v("Description")]
                              ),
                              _vm._v(" "),
                              _c(
                                "a",
                                {
                                  staticClass: "dropdown-item",
                                  on: {
                                    click: function ($event) {
                                      return _vm.insert("{Status}")
                                    },
                                  },
                                },
                                [_vm._v("Status")]
                              ),
                              _vm._v(" "),
                              _vm._l(_vm.attributes, function (attr) {
                                return _c(
                                  "a",
                                  {
                                    key: attr.AttributeId,
                                    staticClass: "dropdown-item",
                                    on: {
                                      click: function ($event) {
                                        return _vm.insert(`{${attr.Name}}`)
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                                        " +
                                        _vm._s(attr.Name) +
                                        "\n                                    "
                                    ),
                                  ]
                                )
                              }),
                            ],
                            2
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-group" }, [
                        _c("textarea", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model.trim",
                              value: _vm.descriptionTemplate,
                              expression: "descriptionTemplate",
                              modifiers: { trim: true },
                            },
                          ],
                          ref: "ta",
                          staticClass: "form-control",
                          attrs: { rows: "5" },
                          domProps: { value: _vm.descriptionTemplate },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) return
                              _vm.descriptionTemplate =
                                $event.target.value.trim()
                            },
                            blur: function ($event) {
                              return _vm.$forceUpdate()
                            },
                          },
                        }),
                        _vm._v(" "),
                        _c("small", { staticClass: "form-text text-muted" }),
                      ]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "modal-footer" }, [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-primary",
                        attrs: { type: "button" },
                        on: { click: _vm.save },
                      },
                      [_vm._v("Save & Close")]
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-outline-secondary",
                        attrs: { type: "button" },
                        on: { click: _vm.close },
                      },
                      [_vm._v("Cancel")]
                    ),
                  ]),
                ]
              ),
            ]
          ),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }